import React, { useEffect, useState } from "react";
import FindDoc7 from "../../components/doc7/findDoc7";
import Loadding from "../../components/common/loadding";
import doc7Service from "../../services/doc7.service";
import moment from "moment";
import ShowDoc from "../../components/common/showDoc";
import { BaseURL } from "../../constants/enum/baseURL.emum";
import DeleteDoc7 from "../../components/doc7/deleteDoc7";
import { useSelector } from "react-redux";

const doc7Context = React.createContext<{
  setDoc7List: any;
}>({ setDoc7List: null });

const Doc7 = () => {
  const me = useSelector((state: any) => state.me);
  const [status, setStatus] = useState(true);

  const [doc7List, setDoc7List] = useState([]);

  useEffect(() => {
    (async () => {
      await doc7Service
        .findDoc7({ year: "", level: "", curriCode: "", selectCurriCode: "" })
        .then((res) => {
          setDoc7List(res.data);
          setStatus(false);
        });
    })();
  }, []);

  if (status) {
    return <Loadding />;
  }
  return (
    <doc7Context.Provider value={{ setDoc7List }}>
      <div className="container">
        <h3 className="text-start mt-3">
          รายงานผลการดำเนินการของหลักสูตร (ลงนามต้นฉบับ)
        </h3>
        <FindDoc7 />
        <div
          className="alert alert-warning text-start text-danger"
          role="alert"
        >
          *กำหนดการส่ง มคอ.7 ภายใน 60 วันหลังจากสิ้นปีการศึกษา
        </div>
        <table className="table table-hover table-responsive  table-striped">
          <thead className="table-dark">
            <tr>
              <th scope="col" className="col-2">
                ปีการศึกษา
              </th>
              <th scope="col" className="col">
                หลักสูตร
              </th>
              <th scope="col" className="col-2">
                วันที่รายงาน
              </th>
              <th scope="col" className="col-2">
                บันทึกนำส่ง
              </th>
              <th scope="col" className="col-2">
                Handle
              </th>
            </tr>
          </thead>
          <tbody>
            {doc7List.map((doc7Item: any) => {
              // console.log(doc7Item.curri.name);

              return (
                <tr key={doc7Item.id}>
                  <td>{doc7Item.year}</td>
                  <td>
                    <div className="row">
                      <div className="col text-start">
                        <h5>
                          {doc7Item.curri.name} ({doc7Item.curri.level})
                        </h5>
                      </div>
                    </div>
                    <div className="row-">
                      <div className="col text-start">
                        รหัสหลักสูตร {doc7Item.curri.curriCode}
                      </div>
                    </div>
                  </td>
                  <td>
                    {moment(doc7Item.dateReport)
                      .add(543, "year")
                      .format("DD/MM/yyyy")}
                  </td>
                  <td>
                    {doc7Item.pathFileSend !== "" && (
                      <ShowDoc
                        btnName="บันทึก"
                        url={`${BaseURL.BASE_URL}/upload/doc7Send/${doc7Item.pathFileSend}`}
                      />
                    )}
                  </td>
                  <td>
                    <ShowDoc
                      btnName="มคอ.7"
                      url={`${BaseURL.BASE_URL}/upload/doc7/${doc7Item.pathFile}`}
                    />
                    {me.role === "Admin" && <DeleteDoc7 doc7={doc7Item} />}
                  </td>
                </tr>
              );
            })}
            {doc7List.length === 0 && (
              <tr>
                <td className="text-danger" colSpan={5}>
                  ไม่พบเอกสาร
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </doc7Context.Provider>
  );
};

export { doc7Context };
export default Doc7;
